import { render, staticRenderFns } from "./agravosPropostaForm.vue?vue&type=template&id=63f0854c"
import script from "./agravosPropostaForm.vue?vue&type=script&lang=js"
export * from "./agravosPropostaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports